import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '@/providers/I18nProvider';
import { useAuth } from '@/providers/AuthProvider';
import { isKisproEmployee } from '@/lib/permissions';

export function Footer() {
  const { t } = useI18n();
  const { user } = useAuth();
  const location = useLocation();

  // Auf Checkin-Seite: Footer ausblenden (Vollbild-Scan)
  if (location.pathname.startsWith('/kurse/checkin')) return null;

  return (
    <footer className="app-footer">
      <a href="https://www.kispro.de/impressum.html" target="_blank" rel="noopener noreferrer">
        {t('footer.imprint')}
      </a>
      <span aria-hidden>|</span>
      <a href="https://www.kispro.de/datenschutz.html" target="_blank" rel="noopener noreferrer">
        {t('footer.privacy')}
      </a>
      <span aria-hidden>|</span>
      <Link to="/debug">{t('footer.debug')}</Link>
      {isKisproEmployee(user) ? (
        <>
          <span aria-hidden>|</span>
          <Link to="/neodev">Dev-Log</Link>
        </>
      ) : null}
    </footer>
  );
}
